const sdServicesModule = angular.module("sdServicesModule", ["ngResource", "ngSanitize", "sdLogger"]);

export default sdServicesModule;
